import z from 'zod';
import { bicField, isValidIban, normalizeIdentifier } from '../utils/identifiers.utils.js';
import { passwordSchema } from '../utils/password.utils.js';
export const CommiteeStatus = {
    awaitingFirstConnection: 'awaitingFirstConnection',
    active: 'active',
    deactivated: 'deactivated',
};
export const baseCommitee = {
    select: {
        id: true,
        name: true,
        phoneNumber: true,
        siret: true,
        active: true,
        createdAt: true,
    },
};
export const commiteeSuggestion = {
    select: {
        id: true,
        cpceId: true,
        name: true,
        phoneNumber: true,
        active: true,
    },
};
export const CreateCommiteeDtoSchema = z.object({
    name: z.string().min(1, 'Le nom est requis'),
    siret: z.string().min(1, 'Le SIRET est requis'),
    phoneNumber: z.string().optional(),
});
export const UpdateCommiteeDtoSchema = z.object({
    name: z.string().min(1, 'Le nom est requis'),
    siret: z.string().min(1, 'Le SIRET est requis'),
});
export const SetCommiteeActiveDtoSchema = z.object({
    active: z.boolean(),
});
// The CSE name, retyped by the admin: a wipe is irreversible and the id alone comes from a row
// they may have mis-clicked, so the server re-checks the confirmation rather than trusting the UI.
export const ResetCommiteeDataDtoSchema = z.object({
    confirmationName: z.string().min(1, 'Le nom du CSE est requis'),
});
export const baseCommiteeUser = {
    select: {
        id: true,
        name: true,
        email: true,
        lastName: true,
        firstName: true,
        status: true,
        createdAt: true,
        updatedAt: true,
        sessions: {
            orderBy: { createdAt: 'desc' },
            take: 1,
            select: {
                createdAt: true,
            },
        },
    },
};
export const baseCommiteeBank = {
    select: {
        id: true,
        nomBanque: true,
        iban: true,
        bic: true,
        financialAccount: { select: { associatedJournalId: true } },
    },
};
export const baseCommiteeWorkplace = {
    select: {
        id: true,
        nomLieu: true,
        adresse: true,
        codePostal: true,
        ville: true,
        siren: true,
        telephone: true,
        status: true,
        manager: true,
        email: true,
    },
};
export const BaseCommiteeBankSchema = z.object({
    nomBanque: z.string().min(1, 'Le nom de la banque est requis'),
    iban: z
        .string()
        .min(1, "L'IBAN est requis")
        .refine((val) => /^FR.{25}$/.test(normalizeIdentifier(val)), {
        message: "L'IBAN doit contenir 27 caractères et commencer par 'FR'",
        abort: true,
    })
        .refine(isValidIban, { message: "L'IBAN est invalide (clé de contrôle incorrecte)" }),
    bic: bicField.optional(),
});
export const BaseCommiteeUserSchema = z.object({
    email: z.email("L'email est invalide"),
    firstName: z.string().min(1, 'Le prénom est requis'),
    lastName: z.string().min(1, 'Le nom est requis'),
    password: passwordSchema.optional(),
});
export const BaseCommiteeWorkplaceSchema = z.object({
    nomLieu: z.string().min(1, 'Le nom du lieu est requis'),
    adresse: z.string().optional(),
    codePostal: z.string().optional(),
    ville: z.string().optional(),
    siren: z.string().optional(),
    telephone: z.string().optional(),
    status: z.enum(['Active', 'Inactive']).optional(),
    manager: z.string().optional(),
    email: z.email("L'email est invalide").optional().or(z.literal('')),
});
// The email is the login identity, held by Better Auth and changed through its own verified flow,
// so the back-office edit stops at the civil name.
export const UpdateCommiteeUserSchema = z.object({
    firstName: z.string().min(1, 'Le prénom est requis'),
    lastName: z.string().min(1, 'Le nom est requis'),
});
export const SetCommiteeUserArchivedSchema = z.object({
    archived: z.boolean(),
});
